import React from 'react'
import { Courses } from '../../component/education/Courses'
import { Camps } from '../../component/education/Camps'

export default function CampsPage() {
  return (
    <>
      <Camps />
    </>
  )
}
